import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { IInquiriesState } from "./slice";
import {
  getInquiriesAsync,
  getSimilarInquiriesAsync
} from "./actions";

type Reducer = (builder: ActionReducerMapBuilder<IInquiriesState>) => void;

export const getInquiriesReducer: Reducer = (builder) => {
  builder.addCase(getInquiriesAsync.pending, (state) => {
    state.inquiries.isLoading = true;
  });

  builder.addCase(getInquiriesAsync.fulfilled, (state, actions) => {
    state.inquiries.isLoading = false;
    state.inquiries.data = actions.payload;
  });

  builder.addCase(getInquiriesAsync.rejected, (state) => {
    state.inquiries.isLoading = false;
    state.inquiries.data = null;
  });
};

export const getSimilarInquiriesReducer: Reducer = (builder) => {
  builder.addCase(getSimilarInquiriesAsync.pending, (state) => {
    state.similarInquiries.isLoading = true;
  });

  builder.addCase(getSimilarInquiriesAsync.fulfilled, (state, actions) => {
    state.similarInquiries.isLoading = false;
    state.similarInquiries.data = actions.payload;
  });

  builder.addCase(getSimilarInquiriesAsync.rejected, (state) => {
    state.similarInquiries.isLoading = false;
    state.similarInquiries.data = null;
  });
};
